import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Paper,
  Divider
} from '@mui/material';
import { RASCI_ROLES } from '../types';

const RASCIRolesDisplay: React.FC = () => {
  return (
    <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
      <Typography variant="h4" gutterBottom sx={{
        fontWeight: 'bold',
        color: 'text.primary',
        textAlign: 'center',
        mb: 3
      }}>
        RASCI Responsibility Assignment Matrix
      </Typography>

      <Box sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'repeat(2, 1fr)',
          md: 'repeat(5, 1fr)'
        },
        gap: 3
      }}>
        {RASCI_ROLES.map((role) => (
          <Card
            key={role.id}
            elevation={4}
            sx={{
              height: '100%',
              transition: 'transform 0.2s ease-in-out',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: 6
              }
            }}
          >
            <Box
              sx={{
                backgroundColor: role.color,
                color: 'white',
                p: 2,
                textAlign: 'center',
                position: 'relative'
              }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: '3rem',
                  fontWeight: 'bold',
                  mb: 1
                }}
              >
                {role.id}
              </Typography>
              <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                {role.name}
              </Typography>
            </Box>

            <CardContent sx={{ p: 2 }}>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mb: 2, fontStyle: 'italic' }}
              >
                {role.description}
              </Typography>

              <Divider sx={{ mb: 2 }} />

              <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>
                Responsibilities:
              </Typography>

              <Box component="ul" sx={{ pl: 2, m: 0 }}>
                {role.responsibilities.map((responsibility, index) => (
                  <Typography
                    key={index}
                    variant="body2"
                    component="li"
                    sx={{ mb: 0.5, color: 'text.secondary' }}
                  >
                    {responsibility}
                  </Typography>
                ))}
              </Box>
            </CardContent>
          </Card>
        ))}
      </Box>
    </Paper>
  );
};

export default RASCIRolesDisplay;